<template>
  <div class="tw-relative tw-my-4 tw-p-4" :class="className">
    <slot name="before"></slot>
    <div class="tw-mb-4 tw-grid tw-grid-cols-1 tw-gap-2">
      <div class="tw-col-span-1 tw-overflow-x-auto">
        <slot name="table"></slot>
      </div>
    </div>
    <slot name="after"></slot>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from "vue";

const props = defineProps<{
  className?: Record<string, boolean> | string[] | string;
}>();

const { className } = toRefs(props);
</script>
